import React, { useEffect, useState } from "react";

import { connect } from 'react-redux';
import { toast } from "react-toastify";
import { withRouter } from 'react-router-dom';

import { AdvancedTable, TableSupport } from 'dsilo-ui-components'

import ConfirmationHandler from '../../components/ConfirmDialog';
import { Loader } from '../../components/loader'

import { getColumns, modifyDataIntoNeededFormat, sharedJSON } from "../../utility/SystemPagesCommonCode/TableUtils";
import { getLastSelectedItemFromUserSession, getPaginationDataFromUserSession, updatePaginationDataToUserSession, updateSelectedItemToUserSession } from "../../utility/SystemPagesCommonCode/UserSession";

import { clearReduxDataOfCurrentComponent, clearSuccessMsg, getPrivileges, deletePrivilegeById } from "../../store/actions";

import { useStyles } from "../../utility/SystemPagesCommonCode/styles";
import { fetchPrivilegeSupport } from '../../utility/AbilityCheck'; // Import ability function

const Privileges = (props) => {
    const classes = useStyles()

    const { appId, formData, data } = props
    const { document } = formData
    const pageUrl = props.page?.url
    const { _id: userId } = props.user
    const { chartUniqueId, chartData } = data
    const isNewV1Theme = document?.appConfig?.theme?.type === "v1.1";

    const [paginationData, setPaginationData] = useState(chartData?.pagination || { page: 0, rowsPerPage: 15 })
    const [state, setState] = useState({ ...sharedJSON });
    const [privilegesList, setPrivilegesList] = useState([]);
    const [previlageData, setPrevilageData] = useState("")
    // Generate abilities based on privileges
    const [ability, setAbility] = useState(null);
    // const ability = defineAbilities(privileges, selectedDataModelID);

    const [highLighterIdForSelectedLineItem, setHighLighterIdForSelectedLineItem] = useState('');

    // const ability = defineAbilities(privileges, selectedDataModelID);
    const [deleteConfirmState, setDeleteConfirm] = useState({
        isOpen: false,
        deleteMessage: "Are you sure you want to delete ?",
        data: null
    })

    useEffect(() => {
        let pageSession = getPaginationDataFromUserSession(userId, pageUrl)
        if (pageSession && pageSession.rowsPerPage) {
            setPaginationData({
                ...paginationData,
                page: pageSession.page,
                rowsPerPage: pageSession.rowsPerPage,
                updateLocalStore: false
            })
        }
        fetchData()
    }, [])

    // When delete privilege is triggered to fetch the data
    useEffect(() => {
        if (formData && formData.document[chartUniqueId + '_deleteprivilege'] && formData.document[chartUniqueId + '_deleteprivilege']?.id) {
            toast.success(formData?.document?.[chartUniqueId + "_deleteprivilege"].message || 'Deleted successfully')
            fetchData()
        }
        return () => {
            props.clearReduxDataOfCurrentComponent({
                key: "document",
                subKey: [chartUniqueId + '_deleteprivilege']
            })
        }
    }, [formData && formData.document[chartUniqueId + '_deleteprivilege']])

    // Update the localStorage in browser whenever pagination data changes
    useEffect(() => {
        if (paginationData && paginationData.updateLocalStore) {
            updatePaginationDataToUserSession(userId, pageUrl, { page: paginationData.page, rowsPerPage: paginationData.rowsPerPage })
        }
    }, [paginationData])

    // When data is updated to redux state from API call
    useEffect(() => {
        if (formData && formData.document[appId + '_privileges']?.length) {
            console.log("privileges page === redux state of privileges", formData.document[appId + '_privileges'])
            let privileges = formData?.document[appId + '_privileges'].map(k => ({
                id: k._id,
                name: k.name,
                description: k.description,
                operations: k.operations.join(', ')
            }))
            console.log("privileges page === modified privileges", privileges)
            setPrivilegesList(privileges)
        }
        else {
            setPrivilegesList([]);
        }
    }, [formData && formData.document[appId + '_privileges']])

    // Modify data to needed format in the table
    useEffect(() => {
        if (privilegesList) {
            let keysArr = ['_id'];
            console.log("privileges page === privileges list", privilegesList)
            let td = TableSupport.setDatafromApi2(
                modifyDataIntoNeededFormat(privilegesList, chartData),
                keysArr,
                state,
                getColumns()
            )
            console.log("privileges page === final data to pass table", td)
            setState({
                ...TableSupport.setDatafromApi2(
                    modifyDataIntoNeededFormat(privilegesList, chartData),
                    keysArr,
                    state,
                    getColumns(privilegesList)
                ),
                count: privilegesList.length
            });
            let lastSelected = getLastSelectedItemFromUserSession(userId, pageUrl)
            console.log("it is last selected tile ===", lastSelected)
            if (lastSelected) {
                setHighLighterIdForSelectedLineItem(lastSelected)
            }
        }
    }, [privilegesList]);

    const fetchData = () => {
        console.log("privileges page === getPrivileges")
        const payload = {
            "appId": appId,
            "orgId": props.user.orgId,
            "dataUniqueId": appId + '_privileges'
        }
        props.getPrivileges(payload)
    }

    const onAddClick = () => {
        props.history.push({ pathname: `/${props.match.params.appid}/page/privilege/new` });
    }

    const tableCrudOperations = (item, type) => {
        console.log("privileges page === item", item, type)
        if (type === 'edit') {
            updateSelectedItemToUserSession(userId, pageUrl, item.id)
            props.history.push({
                pathname: `/${appId}/page/${chartData.editPage}/${item.id}`,
            })
        }
        if (type === 'delete') {
            // deletePrivilegeData(item.id)
            setDeleteConfirm({
                ...deleteConfirmState,
                isOpen: true,
                data: item.id
            })
        }
    }

    // Deleting the Privilege function 
    const deletePrivilegeData = (id) => {
        if (id) {
            const payload = {
                "appId": appId,
                "orgId": props.user.orgId,
                // "id": id,
                "id": deleteConfirmState.data,
                "dataUniqueId": chartUniqueId + '_deleteprivilege'
            }
            props.deletePrivilegeById(payload)
        }
        setDeleteConfirm({ ...deleteConfirmState, isOpen: false, data: null })
    }

    // Pagination related functions
    const handleChangePage = (event, page) => {
        setPaginationData({
            ...paginationData,
            page,
            updateLocalStore: true
        })
    };

    const handleChangeRowsPerPage = event => {
        setPaginationData({
            ...paginationData,
            page: 0,
            rowsPerPage: event.target.value,
            updateLocalStore: true
        })
    };

    // Member Privileges code end here
    useEffect(() => {
        const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
        setPrevilageData(privilegeData);
        setAbility(ability);
    }, [
        props.formData.document[`${props.match.params.appid}_memberprivileges`],
        props?.privilegesSupport,
        props.match.params.page,
        window.location.pathname,
        chartData?.selectedDataModel
    ]);
    // Member Privileges code end here

    return (
        <>
            {
                formData[appId + '_privileges_loading'] ? <Loader /> :
                    <AdvancedTable
                        name={'PrivilegesList'}
                        {...props}
                        {...state}
                        chartData={chartData}
                        // onRowClick={onRowClick}
                        
                        isTableHead={true}
                        isTableSubHeader={false}
                        isExport={false}
                        isViewCoulmns={false}
                        isSearch={false}
                        isFilter={false}
                        hasCheckbox={false}

                        actions={{ edit: true, view: false, delete: true, copy: false, download: false }}
                        isTablePagination={true}
                        pagination={chartData?.pagination}
                        page={paginationData.page}
                        rowsPerPage={paginationData.rowsPerPage}

                        highLighterIdForSelectedLineItem={highLighterIdForSelectedLineItem}

                        // Actions
                        onAddClick={onAddClick}
                        tableCrudOperations={tableCrudOperations}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}

                        // Styles
                        stripRows
                        headerstyle={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            textAlign: "left",
                            backgroundColor: "#"
                        }}
                        subHeaderstyle={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            backgroundColor: "#FFF",
                            textAlign: "left"
                        }}
                        headerClass={classes.headerClass}
                        rowStyle={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            backgroundColor: "none",
                            lineHeight: 1.5,
                            textAlign: "left"
                        }}
                        previlageData={previlageData}
                        ability={ability}
                        isNewV1Theme={isNewV1Theme}
                        title={props.page?.title}
                        classes={classes}
                    />
            }
            <ConfirmationHandler
                open={deleteConfirmState.isOpen}
                handleClose={deletePrivilegeData}
                alertMessageText={deleteConfirmState.deleteMessage}
                classes={classes}
                confirm
            />
        </>
    )
}

const mapDispatchToProps = {
    clearReduxDataOfCurrentComponent,
    clearSuccessMsg,
    getPrivileges,
    deletePrivilegeById
};

const mapStateToProps = state => {
    return {
        formData: state.form,
        member: state.appConfig.members,
        user: state.user,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Privileges));